import Vue from 'vue';
import Component from 'vue-class-component';
import { newsletterService } from '../../../../Services/newsletterService';

@Component({
    name: 'Nieuwsbrief',
    components: {

    },
    computed: {
       
    },
    mounted(this: Nieuwsbrief) {
    }
})
export default class Nieuwsbrief extends Vue {
    public umbracoContent: any = (window as any).newsletterUmbracoContent;
    public currentLanguage: String = (window as any).currentLanguage as String;
    public email: string = '';
    public formSubmitted: boolean = false;
    public formError: boolean = false;

    public submitSubscribeForm() {
        newsletterService.subscribeNewsletter(this.umbracoContent.relatedNodeId, { email: this.email, culture: this.currentLanguage }).then((result: any) => {
            if (result.status == 200) {
                this.formSubmitted = true;
                this.formError = false;
            } else {
                this.formError = true;
            } 
        });
    }
}